module.exports = __webpack_public_path__ + "static/media/arrow_left.0472ea34.svg";